import { render, staticRenderFns } from "./seriesSoporte.vue?vue&type=template&id=74068a10&scoped=true&"
import script from "./seriesSoporte.vue?vue&type=script&lang=js&"
export * from "./seriesSoporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74068a10",
  null
  
)

export default component.exports